import headerReducer from './reducer';

export const { playerShow, citySelectorShow, citySelectorHide, playerHide } = headerReducer.actions;
